var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 15.2C11.9763 15.2 15.1998 11.9765 15.1998 8.00005C15.1998 4.0236 11.9763 0.800049 7.9998 0.800049C4.02335 0.800049 0.799805 4.0236 0.799805 8.00005C0.799805 11.9765 4.02335 15.2 7.9998 15.2ZM11.3362 6.83644C11.6877 6.48497 11.6877 5.91512 11.3362 5.56365C10.9847 5.21218 10.4149 5.21218 10.0634 5.56365L7.0998 8.52726L5.9362 7.36365C5.58473 7.01218 5.01488 7.01218 4.66341 7.36365C4.31194 7.71512 4.31194 8.28497 4.66341 8.63645L6.46341 10.4364C6.81488 10.7879 7.38473 10.7879 7.7362 10.4364L11.3362 6.83644Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.fc19785681b0ea95f90bb885d5e99bc2.svg";
export { ForwardRef as ReactComponent };